// https://observablehq.com/@namitmohale/enps-chart@925
import define1 from "./a33468b95d0b15b0@699.js";

export default function define(runtime, observer) {
  const main = runtime.module();
  main.variable(observer()).define(["md"], function(md){return(
md`# ENPS Chart

Population by age and state. Compare to [horizontal stacked bars](/@d3/stacked-horizontal-bar-chart), [normalized stacked bars](/@d3/stacked-normalized-horizontal-bar), [grouped bars](https://observablehq.com/@d3/grouped-bar-chart) and a [dot plot](/@d3/dot-plot). Data: [American Community Survey](/@mbostock/working-with-the-census-api)`
)});
  main.variable(observer("chart")).define("chart", ["d3","width","height","titleText","titleY","titleSize","xAxis","yAxis","yAxisRight","series","color","x","y","formatValue","margin","labelY","dotRadius","labelSize","pathData","manageEnpsPoints","enpsPathPoints","pathDataResp","manageNumResponsePoints","numResponsePathPoints"], function(d3,width,height,titleText,titleY,titleSize,xAxis,yAxis,yAxisRight,series,color,x,y,formatValue,margin,labelY,dotRadius,labelSize,pathData,manageEnpsPoints,enpsPathPoints,pathDataResp,manageNumResponsePoints,numResponsePathPoints)
{
  const svg = d3.create("svg")
      .attr("viewBox", [0, 0, width, height]);

  svg.append("g").append('text')
     .text(titleText)
     .attr('y', titleY)
      .attr('x', width/2 - titleText.length * titleSize/4)
     .style('font-size', titleSize);
  
  
  svg.append("g")
      .attr("class", "x-axis")
      .call(xAxis);

  svg.append("g")
      .call(yAxis);
  svg.append("g")
      .call(yAxisRight);
  
  // svg.append("g")
  //     .style("overflow-x", "scroll")
  //     .style("-webkit-overflow-scrolling", "touch");
  
  svg.append("g")
    .selectAll("g")
    .data(series)
    .join("g")
      .attr("fill", d => color(d.key))
    .selectAll("rect")
    .data(d => d)
    .join("rect")
      .attr("x", (d, i) => x(d.data.name) + 5)
      .attr("y", d => y(d[1]))
      .attr("height", d => y(d[0]) - y(d[1]))
      .attr("width", x.bandwidth())
    .append("title")
      .text(d => `${d.data.name} \n${d.key}: ${formatValue(d.data[d.key])}`);

  
  // svg.selectAll("mydots")
  //   .data(series.map(d => d.key))
  //   .enter()
  //   .append("circle")
  //   .attr("cx", width-margin.right+50)
  //   .attr("cy", function(d,i){ return 20 + i*25})
  //   .attr("r", dotRadius)
  //   .style("fill", function(d){ return color(d)})
  
  svg.selectAll("mydots")
    .data(series.map(d => d.key))
    .enter()
    .append("circle")
    .attr("cx", function(d,i){return margin.left+150+i*width/4})
    .attr("cy", function(d,i){ return labelY})
    .attr("r", dotRadius)
    .style("fill", function(d){ return color(d)})
  
  // svg.selectAll("mydots")
  //   .append("circle")
            
  // svg.selectAll("mylabels")
  //   .data(series.map(d => d.key))
  //   .enter()
  //   .append("text")
  //   .attr("x", width-margin.right+65)
  //   .attr("y", function(d,i){ return 20 + i*25})
  //   .style("fill", function(d){ return color(d)})
  //   .text(function(d){ return d.charAt(0).toUpperCase() + d.slice(1)})
  //   .attr("text-anchor", "left")
  //   .style("alignment-baseline", "middle")
  //   .style("font-size", labelSize)
  
  svg.selectAll("mylabels")
    .data(series.map(d => d.key))
    .enter()
    .append("text")
    .attr("x", function(d,i){ return margin.left+165+i*width/4 })
    .attr("y", function(d,i){ return labelY+dotRadius-labelSize/2})
    .style("fill", function(d){ return color(d)})
    .text(function(d){ return d.charAt(0).toUpperCase() + d.slice(1)})
    .attr("text-anchor", "left")
    .style("alignment-baseline", "middle")
    .style("font-size", labelSize)

  svg.append('path')
    .attr("fill", "none")
      .attr("stroke", "red")
      .attr("stroke-width", 2.5)
      .attr("stroke-linejoin", "round")
      .attr("stroke-linecap", "round")
    .attr('d', pathData);
  
  svg.append('g')
	.selectAll('circle')
	.data(manageEnpsPoints(enpsPathPoints))
	.enter()
	.append('circle')
	.attr('cx', function(d) {return d[0];})
	.attr('cy', function(d) {return d[1];})
	.attr('r', 4);
  
  svg.append('path')
    .attr("fill", "none")
      .attr("stroke", "green")
      .attr("stroke-width", 2.5)
      .attr("stroke-linejoin", "round")
      .attr("stroke-linecap", "round")
    .attr('d', pathDataResp);
  
  svg.append('g')
	.selectAll('circle')
	.data(manageNumResponsePoints(numResponsePathPoints))
	.enter()
	.append('circle')
	.attr('cx', function(d) {
		return d[0];
	})
	.attr('cy', function(d) {
		return d[1];
	})
	.attr('r', 4);
  
  return svg.node();
}
);
  main.variable(observer("labelY")).define("labelY", function(){return(
60
)});
  main.variable(observer("titleY")).define("titleY", function(){return(
30
)});
  main.variable(observer("pathData")).define("pathData", ["lineGenerator","manageEnpsPoints","enpsPathPoints"], function(lineGenerator,manageEnpsPoints,enpsPathPoints){return(
lineGenerator(manageEnpsPoints(enpsPathPoints))
)});
  main.variable(observer("enpsPathPoints")).define("enpsPathPoints", function(){return(
[
	['Jun-01-20', -40],
	['Jul-05-20', -20],
	['Aug-02-20', -15],
	['Sep-08-20', -15],
	['Oct-09-20', -20],
	['Nov-23-20', -10],
  ['Dec-02-20', 50],
  ['Dec-14-20', -45],
  ['Dec-23-20', 40],
]
)});
  main.variable(observer("numResponsePathPoints")).define("numResponsePathPoints", function(){return(
[
	['Jun-01-20', 60],
	['Jul-05-20', 20],
	['Aug-02-20', 15],
	['Sep-08-20', 45],
	['Oct-09-20', 20],
	['Nov-23-20', 10],
  ['Dec-02-20', 50],
  ['Dec-14-20', 5],
  ['Dec-23-20', 40],
]
)});
  main.variable(observer("yRightMax")).define("yRightMax", ["numResponsePathPoints"], function(numResponsePathPoints){return(
numResponsePathPoints.reduce((accum, curr) =>  curr[1]>accum?curr[1]:accum, 0)
)});
  main.variable(observer()).define(["manageEnpsPoints","enpsPathPoints"], function(manageEnpsPoints,enpsPathPoints){return(
manageEnpsPoints(enpsPathPoints)
)});
  main.variable(observer("manageEnpsPoints")).define("manageEnpsPoints", ["x","y"], function(x,y){return(
function manageEnpsPoints(inp){
  var temppoints = []
  for(const item of inp){
  temppoints.push([x(item[0])+5 + x.bandwidth()/2, y(item[1])])
}
  return temppoints
}
)});
  main.variable(observer("manageNumResponsePoints")).define("manageNumResponsePoints", ["x","yRight"], function(x,yRight){return(
function manageNumResponsePoints(inp){
  var temppoints = []
  for(const item of inp){
  temppoints.push([x(item[0])+5 + x.bandwidth()/2, yRight(item[1])])
}
  return temppoints
}
)});
  main.variable(observer("pathDataResp")).define("pathDataResp", ["lineGenerator","manageNumResponsePoints","numResponsePathPoints"], function(lineGenerator,manageNumResponsePoints,numResponsePathPoints){return(
lineGenerator(manageNumResponsePoints(numResponsePathPoints))
)});
  main.variable(observer("lineGenerator")).define("lineGenerator", ["d3"], function(d3){return(
d3.line()
	.curve(d3.curveCardinal)
)});
  main.variable(observer("wrap")).define("wrap", ["d3"], function(d3){return(
(text) => {
        const width=50
        text.each(function() {
          var text = d3.select(this),
              words = text.text().split(/\s+/).reverse(),
              word,
              line = [],
              lineNumber = 0,
              lineHeight = 1.1, // ems
              y = text.attr("y"),
              dy = parseFloat(text.attr("dy")),
              tspan = text.text(null).append("tspan").attr("x", 0).attr("y", y).attr("dy", dy + "em");
          while (words.length >0) {
              word=words.pop()
            line.push(word);
            tspan.text(line.join(" "));
            // if (tspan.node().getComputedTextLength() > width) {
              line.pop();
              tspan.text(line.join(" "));
              line = [word];
              tspan = text.append("tspan").attr("x", 0).attr("y", y-10).attr("dy", ++lineNumber * lineHeight + dy + "em").text(word);
            // }
          }
        });
      }
)});
  main.variable(observer("text")).define("text", function(){return(
"name,Detractors,Passives,Promoters\rJun-01-20,60,20,20\rJul-05-20,30,60,10\rAug-02-20,35,45,20\rSep-08-20,25,65,10\rOct-09-20,40,40,20\rNov-23-20,20,70,10\rDec-02-20,10,30,60\rDec-14-20,50,45,5\rDec-23-20,20,20,60\r"
)});
  main.variable(observer("data")).define("data", ["d3","text"], function(d3,text){return(
d3.csvParse(text, (d, i, columns) => (d3.autoType(d), d.total = d3.sum(columns, c => d[c]), d)).sort((a, b) => b.total - a.total)
)});
  main.variable(observer("series")).define("series", ["d3","data"], function(d3,data){return(
d3.stack()
    .keys(data.columns.slice(1))
  (data)
    .map(d => (d.forEach(v => v.key = d.key), d))
)});
  main.variable(observer("x")).define("x", ["d3","data","margin","width"], function(d3,data,margin,width){return(
d3.scaleBand()
    .domain(data.map(d => d.name))
    .range([margin.left, width - margin.right])
    .padding(0.1)
)});
  main.variable(observer("y")).define("y", ["d3","series","height","margin"], function(d3,series,height,margin){return(
d3.scaleLinear()
    .domain([-100, d3.max(series, d => d3.max(d, d => d[1]))])
    .rangeRound([height - margin.bottom, margin.top])
)});
  main.variable(observer("yRight")).define("yRight", ["d3","yRightMax","height","margin"], function(d3,yRightMax,height,margin){return(
d3.scaleLinear()
    .domain([0, yRightMax])
    .rangeRound([height - margin.bottom, margin.top])
)});
  main.variable(observer("color")).define("color", ["d3","series","colorRange"], function(d3,series,colorRange){return(
d3.scaleOrdinal()
  .domain(series.map(d => d.key))
  .range(colorRange)
)});
  main.variable(observer("xAxis")).define("xAxis", ["height","margin","d3","x","xTextSize","wrap"], function(height,margin,d3,x,xTextSize,wrap){return(
g => g
    .attr("transform", `translate(0,${height - margin.bottom})`)
    .call(d3.axisBottom(x).tickSizeOuter(0))
    .attr('font-size', xTextSize)
    .selectAll("text").call(wrap, x.bandwidth())
    .call(g => g.selectAll(".domain").remove())
)});
  main.variable(observer("yAxis")).define("yAxis", ["margin","d3","y"], function(margin,d3,y){return(
g => g
    .attr("transform", `translate(${margin.left},0)`)
    .call(d3.axisLeft(y))
    .call(g => g.select(".domain").remove())
    .call(g => g.select(".tick:last-of-type text").clone()
      .attr("x", -40)
        .attr("y", -30)
        .attr("text-anchor", "start")
        .attr("font-weight", "bold")
          .attr("font-size", 12)
          .style('fill', 'red')
        .text("ENPS Score"))
)});
  main.variable(observer("yAxisRight")).define("yAxisRight", ["width","margin","d3","yRight"], function(width,margin,d3,yRight){return(
g => g
    .attr("transform", `translate(${width - margin.right},0)`)
    .call(d3.axisRight(yRight).ticks(null, "s"))
    .call(g => g.select(".domain").remove())
    .call(g => g.select(".tick:last-of-type text").clone()
      .attr("x", -45)
        .attr("y", -30)
        .attr("text-anchor", "start")
        .attr("font-weight", "bold")
          .attr("font-size", 12)
          .style('fill', 'green')
        .text("Num Responses"))
)});
  main.variable(observer("xTextSize")).define("xTextSize", function(){return(
13
)});
  main.variable(observer("yTextSize")).define("yTextSize", function(){return(
15
)});
  main.variable(observer("colorRange")).define("colorRange", function(){return(
["#1b9e77","#d95f02","#7570b3","#e7298a","#66a61e","#e6ab02","#a6761d","#666666"]
)});
  main.variable(observer("titleText")).define("titleText", function(){return(
"eNPS Report"
)});
  main.variable(observer("titleSize")).define("titleSize", function(){return(
18
)});
  main.variable(observer("dotRadius")).define("dotRadius", function(){return(
8
)});
  main.variable(observer("labelSize")).define("labelSize", function(){return(
15
)});
  main.variable(observer("formatValue")).define("formatValue", function(){return(
x => isNaN(x) ? "N/A" : x.toLocaleString("en")
)});
  main.variable(observer("height")).define("height", function(){return(
400
)});
  main.variable(observer("margin")).define("margin", function(){return(
{top: 100, right: 50, bottom: 50, left: 50}
)});
  main.variable(observer("d3")).define("d3", ["require"], function(require){return(
require("d3@6")
)});
  const child1 = runtime.module(define1);
  main.import("legend", child1);
  return main;
}
